import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useState } from "react";
import imgVerriere from "../assets/images/VitalEau-Lieu-5.jpg";
import { GoPloof } from "../components/organisms/GoPloof";
import MetaMaster from "../components/utils/MetaMaster";
import { Button } from "../stories/atoms/Button";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function Inscription() {
    const [arianeItem] = useState([
        ["/", "Vital'Eau"],
        ["/inscription", "Inscription"],
    ]);

    return (
        <div className="pageinscription">
            <MetaMaster title={"Vital'eau - Inscription"} />
            <HeroInner arianeItem={arianeItem} imagesSwiper={[imgVerriere]} />
            <section className="section-show-pool-home section-inscription" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h1 className="accueil-histoire-titre h1-inner" data-title="Inscription">
                                    Inscription
                                </h1>
                                <p id="accueil-histoire-baseline"></p>
                                <p className="text-center">
                                    Pour devenir membre Vital’Eau ou renouveler votre abonnement,
                                    <br /> suivez les indications ci-dessous.
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            <GoPloof />
            <section className="section-contact">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h2 className="accueil-histoire-titre" data-title="Des questions ?">
                                    Des questions ?
                                </h2>
                                <p className="text-center">
                                    Besoin d’informations ? Envie d’en savoir plus sur nos activités et notre fonctionnement ? <br />
                                    Nous sommes disponibles pour répondre à toutes vos demandes !
                                </p>
                                <br />
                                <br />
                                <Button label="Nous contacter" style={{ width: "fit-content", margin: "0 auto" }} primary href={"/contact"} />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </div>
    );
}
